<!-- Toast Notification Container -->
<div class="toast-container">
  <div 
    *ngFor="let notification of notifications; trackBy: trackByNotificationId" 
    class="toast-notification"
    [ngClass]="getNotificationClass(notification.type)"
    (click)="onNotificationClick(notification)">
    
    <!-- Notification Content -->
    <div class="toast-content">
      <!-- Icon -->
      <div class="toast-icon">
        <i [class]="getNotificationIcon(notification.type)"></i>
      </div>
      
      <!-- Message Content -->
      <div class="toast-message">
        <div class="toast-title">{{ notification.title }}</div>
        <div class="toast-text">{{ notification.message }}</div>
        <div class="toast-timestamp">{{ formatTimestamp(notification.timestamp) }}</div>
      </div>
      
      <!-- Close Button -->
      <button 
        *ngIf="notification.showCloseButton"
        class="toast-close"
        (click)="removeNotification(notification.id); $event.stopPropagation()"
        title="Dismiss notification">
        <i class="bi bi-x"></i>
      </button>
    </div>
    
    <!-- Progress Bar for timed notifications -->
    <div 
      *ngIf="notification.duration && notification.duration > 0" 
      class="toast-progress">
      <div class="toast-progress-bar"></div>
    </div>
  </div>
</div>




